import keyMirror from 'keymirror';

const appConstants = keyMirror({
  // DEPRECATED?
  SHOW_SPINNER: null,
  HIDE_SPINNER: null,

  HEADER_COLLAPSE: null,
  HEADER_EXPAND: null,

  GET_NEXT_TASK: null,
  NAVIGATE_TO_TASK: null,
  CLEAR_TASKS: null,
  CLEAR_WEB_TASK: null,
  NAVIGATE_TO_WEB_TASK: null,
  NAVIGATE_TO_WEB_TASK_MOVEMONEY: null,

  TRACK_API_CALL_STARTED: null,
  TRACK_API_CALL_COMPLETE: null,

  LOGOUT_USER: null,
  RESET_DATA: null,

  GET_SESSION_COP_CHECKS: null,
  SET_SESSION_COP_CHECKS: null,
});

export const CHANGE_EVENT = 'change';

export default appConstants;
